import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    viewSingleMeter:false,
    singleMeterValue: "",
    consumptionLimitMax: 0
};

export const systemAnalysisSlice = createSlice({
    name: 'systemAnalysis',
    initialState,
    reducers: {
        SET_VIEW_SINGLE_METER: (state, {payload}) => {
            state.viewSingleMeter = payload;
        },
        SET_SINGLE_METER_VALUE: (state, {payload}) => {
            state.singleMeterValue = payload;
        },
        SET_CONSUMPTION_LIMIT_MAX: (state, {payload}) => {
            state.consumptionLimitMax = payload;
        }
    },
});

export const {SET_VIEW_SINGLE_METER, SET_SINGLE_METER_VALUE, SET_CONSUMPTION_LIMIT_MAX} = systemAnalysisSlice.actions;

export default systemAnalysisSlice.reducer;